export default __webpack_public_path__ + "static/media/1247.eb97be15.png";